import * as React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import t from '../../shared/translations';
import { Dispatch, openModal } from '../state';
import { ICurrentPerson } from './Profile';
import { Button as OrgiButton } from './stylins';

interface IProps {
    person: ICurrentPerson;
}

const Row = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (min-width: 768px) {
        flex-direction: row;
        justify-content: space-between;
    }
`;

const Datum = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (min-width: 768px) {
        flex-direction: row;
        align-items: baseline;
    }
`;

const FakeLabel = styled.span`
    margin-bottom: 0;
    padding-bottom: 0;
    display: block;
    font-size: 0.875rem;
    color: #4d4d4d;
    text-align: center;
    width: 100%;
    @media (min-width: 768px) {
        padding: 0.5625rem 0;
        margin-bottom: 1rem;
        text-align: right;
        width: 180px;
    }
`;

const StaticData = styled.div`
    padding: 0.5rem;
    margin-bottom: 1rem;
`;

const Button = styled(OrgiButton)`
    @media (min-width: 768px) {
        order: 1;
    }
`;

function InfoSection({ person }: IProps): JSX.Element {
    const dispatch = useDispatch<Dispatch>();

    const open = () => {
        dispatch(openModal('Profile/ChangePassword'));
    };

    return <section>
        <Row>
            <Button onClick={open}>
                {t('player.profile.button-change-password')}
            </Button>
            <Datum>
                <FakeLabel>{t('player.profile.label-organisation')}</FakeLabel>
                <StaticData>{person.organisation.name}</StaticData>
            </Datum>
        </Row>
        <Datum>
            <FakeLabel>{t('player.profile.label-team')}</FakeLabel>
            <StaticData>{person.team ? person.team.name : ''}</StaticData>
        </Datum>
    </section>;
}

export default InfoSection;
